import { Grid, Icon, Typography } from "@gupshup-frontend/gupshup-ts-components";

import {
  ORDER_STATUS,
  TEMPLATE_PREVIEW_DATA_TESTID,
}                                 from "./constant";
import styles                     from "./style.module.css";

const OrderStatus = () => {

  return (
    <Grid className = {styles.orderStatusPanel} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_STATUS_PANEL}>
      <Grid display = "flex" flexDirection = "column" gap = {0.7} paddingLeft = {0.5} >
        <Typography className = {styles.orderStatusHeader} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_STATUS_MESSAGE}>
          {ORDER_STATUS.MESSAGE}
        </Typography>
        <Grid className = {styles.orderStatusSubHeader}>
          <Typography variant = "caption" lineHeight = {1} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_STATUS_HEADER}>
            {ORDER_STATUS.ORDERID}
          </Typography>
          <Typography variant = "caption" lineHeight = {1} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_STATUS_SUBHEADER}>
            {ORDER_STATUS.SUBHEADER}
          </Typography>
        </Grid>
      </Grid>
      <Icon
        size       = {65}
        alt        = "Order Status Icon"
        customPath = {ORDER_STATUS.ICONPATH}
        dataTestId = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_STATUS_ICON}
      />
    </Grid>
  );
};

export default OrderStatus;
